import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';

import Theme from '../../theme';

const BookingFlowFooter = ({ children, style }) => (
  <View style={[styles.container, style]}>
    {children}
  </View>
);

const styles = StyleSheet.create({
  container: {
    justifyContent: 'flex-end',
    padding: 15,
    marginHorizontal: -15,
    marginBottom: -15,
    backgroundColor: Theme.WHITE,
    shadowColor: Theme.GREY_LIGHT,
    shadowRadius: 2,
    shadowOffset: {
      width: 0,
      height: -5,
    },
    shadowOpacity: 1,
    ...Platform.select({
      android: {
        elevation: 10,
      },
      web: {
        boxShadow: `0px -3px 3px -2px rgba(184,184,184,0.75);`
      }
    })
  },
})

export default BookingFlowFooter;
